/* eslint-disable @typescript-eslint/no-explicit-any */
import isEqual from 'lodash/isEqual'

interface PromiseCache {
  promise?: Promise<void>
  inputs: Array<any>
  error?: any
  response?: any
}

const promiseCaches: PromiseCache[] = []

/** Wraps a function that returns a Promise to support react Suspense */
export const wrapPromise = (
  promise: (...inputs: Array<any>) => any,
  inputs: Array<any>,
  lifespan = 0,
): any => {
  for (const promiseCache of promiseCaches) {
    if (isEqual(inputs, promiseCache.inputs)) {
      if (Object.prototype.hasOwnProperty.call(promiseCache, 'error')) {
        throw promiseCache.error
      }
      if (Object.prototype.hasOwnProperty.call(promiseCache, 'response')) {
        return promiseCache.response
      }
      throw promiseCache.promise
    }
  }

  const promiseCache: PromiseCache = {
    promise:
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      promise(...inputs)
        .then((response: any) => {
          promiseCache.response = response
        })
        .catch((e: any) => {
          promiseCache.error = e
        })
        .then(() => {
          if (lifespan > 0) {
            setTimeout(() => {
              const index = promiseCaches.indexOf(promiseCache)
              if (index !== -1) {
                promiseCaches.splice(index, 1)
              }
            }, lifespan)
          }
        }),
    inputs,
  }
  promiseCaches.push(promiseCache)
  throw promiseCache.promise
}

export default wrapPromise
